// @flow
import { and, uiTypeIs, schemaTypeIs } from '@jsonforms/core';

export type Tester = $FixMe;

export const isBooleanView: Tester = and(
    uiTypeIs('View'),
    schemaTypeIs('boolean')
);

export const isStringView: Tester = and(
    uiTypeIs('View'),
    schemaTypeIs('string')
);

export const isNumberView: Tester = and(
    uiTypeIs('Control'),
    schemaTypeIs('number')
);
